<template>
      <div class="wrapper wrapper-content">
        <div class="container-fluid">


<div class="">
              
  
  
  
    
  
  
    
  


  <div class="row affiliate">
    <div class="col-lg-12">
      <div class="tabs-container">
        <ul class="nav nav-tabs">
          <li style="background:#eaeaea">
            <router-link :to="{name: 'affiliate'}" class="no-margins text-center"><i class="fa fa-fw fa-globe"></i> ภาพรวม</router-link>
          </li>
          <li class="active">
            <router-link :to="{name: 'af_member'}" class="no-margins text-center text-nowrap"><i class="fa fa-fw fa-user-circle"></i> สมาชิก</router-link>
          </li>
          <li style="background:#eaeaea">
            <router-link :to="{name: 'af_revenue'}" class="no-margins text-center text-nowrap"><i class="fa fa-fw fa-money"></i> รายได้</router-link>
          </li>
          <li style="background:#eaeaea">
            <router-link :to="{name: 'af_withdraw'}" class="no-margins text-center text-nowrap"><i class="fa fa-fw fa-bell"></i> แจ้งถอนรายได้</router-link>
          </li>
        </ul>

        <div class="tab-content">
          <div class="tab-pane active">
            <div class="panel-body p-xs">

              <div class="table-responsive">

                <data-tables style="font-size: 10px; width: 100%" :data="affiliate_result" :pagination-props="{ pageSizes: [20, 50, 100] }" :table-props="afTableProps" >
                  
                  <el-table-column prop="username" label="ยูสเซอร์เนม" width="auto">
                      <template slot-scope="scope">
                        <a href="#order-history-modal" data-toggle="modal" @click="loadOrderHistory(scope.row.id, scope.row.username)">{{ scope.row.username }}</a>
                      </template>
                  </el-table-column>
                  <el-table-column prop="balance" label="เครดิตคงเหลือ" width="auto">
                      <template slot-scope="scope">
                        <div>{{ formatMoney((scope.row.balance).toFixed(2)) }} </div>
                      </template>
                  </el-table-column>
                  <el-table-column prop="status" label="สถานะ" width="100" >
                    <template slot-scope="scope">
                          <span class="label label-success" v-if="scope.row.active">Active</span>
                          <span class="label label-danger" v-else>Inactive</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="created_at" label="วันที่สมัคร" width="auto">
                      <template slot-scope="scope">
                        <div>{{ formatDate(scope.row.created_at) }} </div>
                      </template>
                  </el-table-column>

                </data-tables>


              </div> <!-- /.table-responsive -->
            </div> <!-- /.ibox-content -->
          </div>
        </div>


      </div> <!-- /.tabs-container -->

    </div> <!-- /.col-lg-12 -->
  </div> <!-- /.row -->


<div id="order-history-modal"  role="dialog" aria-hidden="true" class="modal inmodal">
  <div class="modal-dialog">
    <div class="modal-content animated fadeIn">

      <div class="modal-header">
        <button type="button" ref="closeOrderHistory" data-dismiss="modal" class="close">
          <span aria-hidden="true">×</span>
          <span class="sr-only">Close</span>
        </button> 
        <h4 class="modal-title">รายละเอียดโพย ของ {{ current_username }}</h4>
      </div>

      <div class="modal-body p-sm border-bottom">
        <div class="tabs-container">

          <div id="orderHistory" class="tab-pane tab-numbersets">

              <data-tables style="font-size: 10px; width: 100%" :data="orderHistoryData" :pagination-props="{ pageSizes: [20, 50, 100] }" :table-props="numberTableProps" >
                <el-table-column prop="oh_ordnum" label="เลขที่รายการ" width="auto">
                    <template slot-scope="scope">
                      #{{scope.row.oh_ordnum}}
                      <!-- <a href="#item-history-modal" data-toggle="modal" @click="selectOrder(scope.row)">#{{scope.row.oh_ordnum}}</a> -->
                    </template>
                </el-table-column>
                <el-table-column prop="description" label="งวดที่" width="auto">
                </el-table-column>
                <el-table-column prop="created_at" label="วันที่ / เวลา" width="auto">
                    <template slot-scope="scope">
                      <div>{{ formatDate(scope.row.created_at) }} </div>
                    </template>
                </el-table-column>
                <el-table-column prop="oh_total" label="เงินเดิมพัน" width="100" >
                  <template slot-scope="scope">
                    <div>{{ formatMoney( (scope.row.oh_total).toFixed(2) ) }} </div>
                  </template>
                </el-table-column>
                <el-table-column prop="af_amt" label="รายได้" width="100" >
                  <template slot-scope="scope">
                    <div>{{ formatMoney( (scope.row.af_amt).toFixed(2) ) }} </div>
                  </template>
                </el-table-column>
              </data-tables>

          </div>

        </div>
      </div>

    </div>
  </div>
</div>


<div id="item-history-modal"  role="dialog" aria-hidden="true" class="modal inmodal" v-if="itemHistoryData.length > 0">
  <div class="modal-dialog">
    <div class="modal-content animated fadeIn">

      <div class="modal-header">
        <button type="button" ref="closeitemHistory" data-dismiss="modal" class="close">
          <span aria-hidden="true">×</span>
          <span class="sr-only">Close</span>
        </button> 
        <h4 class="modal-title">รายละเอียดโพย {{ current_ordernumber }}</h4>
      </div>

      <div class="modal-body p-sm border-bottom">
        <div class="tabs-container">

          <div id="itemHistory" class="tab-pane tab-numbersets">

              <data-tables style="font-size: 10px; width: 100%" :current-page.sync="currentPage" :page-size="pageSize" :data="itemHistoryData" :pagination-props="{ pageSizes: [20, 50, 100] }" :table-props="numberTableProps" >

                <el-table-column type="index">
                    <template slot-scope="scope">
                      {{ getIndex(scope.$index) }}
                    </template>
                </el-table-column>

                <el-table-column prop="type" label="ประเภทหวย" width="auto">
                    <template slot-scope="scope">
                      {{ bettypeTextMapping[scope.row.bettype_id] }}
                    </template>
                </el-table-column>
                <el-table-column prop="number" label="เลขที่แทง" width="auto">
                </el-table-column>
                <el-table-column prop="bet_value" label="ราคาที่แทง" width="auto">
                    <template slot-scope="scope">
                      <div>{{ formatMoney( (scope.row.bet_value).toFixed(2) ) }} </div>
                    </template>
                </el-table-column>
                <el-table-column prop="result" label="ผลได้เสีย" width="100" >
                  <template slot-scope="scope">
                    <div class="text-green" v-if="scope.row.oi_win > 0">{{ scope.row.win_price }}</div>
                    <div v-else>0</div>
                  </template>
                </el-table-column>
              </data-tables>

          </div>

        </div>
      </div>

    </div>
  </div>
</div>

            </div>


        </div>
      </div><!-- /#page-wrapper -->
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: 'af_member',
    data () {
        return {
            refer_link: '',
            affiliate_result: [],
            numberTableProps: {
                border: true,
                stripe: true,
                // 'show-summary': true,
                defaultSort: {
                    prop: 'created_at',
                    order: 'descending'
                },
            },
            afTableProps: {
                border: true,
                stripe: true,
                defaultSort: {
                    prop: 'id',
                    order: 'ascending'
                },
            },
            orderHistoryData: [],
            itemHistoryData: [],
            current_username: '',
            current_ordernumber: '',

            bettypeTextMapping: {
                4: 'สามตัวบน',
                1: 'สามตัวโต๊ด',
                2: 'สามตัวหน้า',
                3: 'สามตัวหลัง',
                5: 'สามตัวล่าง', //TODO: not implement yet
                6: 'สองตัวบน',
                7: 'สองตัวล่าง',
                8: 'วิ่งบน',
                9: 'วิ่งล่าง',
            },

            currentPage: 1,
            pageSize: 20,
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            affiliate: state => state.affiliate.affiliate,
        }),
    },
    methods: {
        createReferLink () {

            if ( this.user ) {
                let baseUrl = location.origin
                this.refer_link = baseUrl + '/register/' + this.user.refer_token
            }
            return this.refer_link

        },
  
        async getAffiliateMember () {
            
            if ( this.affiliate.member_data ) {
                //console.log('state initial getAffiliateMember', this.affiliate)
                this.affiliate_result = this.affiliate.member_data
            }
            else {
                try {

                    const response = await this.$store.dispatch('affiliate/getAffiliate', this.user.id )
                    //console.log('async initial getAffiliateMember', response)

                    if ( response && response.member_data.length > 0 ) {
                        this.affiliate_result = response.member_data
                    }

                } catch (error) {
                    this.$toasted.error('There was an error connecting to the server.')
                }
            }


        },

        formatDate (value) {
            if (value) {
                let date = new Date(value)
                return moment(date).format('DD/MM/YYYY HH:mm:ss')
            }
        },

        formatMoney(num) {
            if (num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            }
            return num
        },

        async loadOrderHistory (af_user_id, af_user_name) {

            this.current_username = af_user_name

            let loader = this.$loading.show()
            try {
                const response = await this.$store.dispatch('orderhead/getAFUsersOrderhead', { af_user_id: af_user_id, order: 'desc', type: 'lotto' })
                //console.log('async loadOrderHistory', response)

                this.orderHistoryData = response.orderData

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            } finally {
                loader.hide()
            }
        },

        async selectOrder (item) {

            this.current_ordernumber = item.oh_ordnum


            try {

                const response = await this.$store.dispatch('orderitem/getAFOrderitem', { order_id: item.id, af_user_id: item.user_id })
                //console.log('response: ', response)

                this.itemHistoryData = response

                this.currentPage = 1

            } catch (error) {
                console.log('error', error)
                this.$toasted.error('There was an error connecting to the server.')
            }
        },

        // handleCurrentChange(currentRow) {
        //     console.log('handleCurrentChange', currentRow)
        //     this.current_ordernumber = currentRow.oh_ordnum
        //     this.selectOrder(currentRow.id)
        // },

        getIndex(rowIndex) {
            //console.log('logScope', rowIndex)
            let index = rowIndex + 1
            if ( this.currentPage > 1 ) {
                index = index + this.pageSize
            }
            return index

        }

    },
    created () {
        //console.log('crypto')
        this.getAffiliateMember()

    },
    destroyed () {
    },
    mounted () {
    },
}
</script>

<style lang="sass" scoped>
</style>
